<template>
    <div
        class="md-form broker get-more-info-v8"
        :style="{ paddingTop, marginBottom }"
    >
        <div class="f-col form-container">
            <div class="info-agent">
                <div class="img">
                    <AgentHeadShot :headshots="agent.headShots" :initImage="agent.image" :alt="$t('md-form.agentavatar')" keyClass="md-form-broker" />
                </div>
                <div
                    class="desc"
                    v-html="bandInfo"
                    style="font-family: var(--font-medium)"
                ></div>
                <div class="concat">
                    <p v-if="agent.phone">
                        <i class="iconfont icon-phone1"></i>
                        <span><a
                            :href="'tel:' + agent.phone"
                            rel="noopener noreferrer"
                        >{{ $ft.formatPhone(agent.phone) }}</a></span>
                    </p>
                    <p v-if="agent.email">
                        <i class="iconfont icon-email"></i>
                        <span>
                            <a
                                :href="'mailTo:' + agent.email"
                                rel="noopener noreferrer"
                            >{{ agent.email }}</a></span>
                    </p>
                    <p v-if="agent.address">
                        <i class="iconfont icon-map-v1"></i>
                        <span>{{ agent.address }}</span>
                    </p>
                </div>
            </div>
            <div class="info-right">
                <div class="top-border"></div>
                <div
                    v-if="title"
                    class="title"
                    v-html="formatFontSize(title, 18)"
                ></div>
                <info-form
                    :registerRole="registerRole"
                    :tag="tag"
                    :questionnaire="questionnaire"
                    :onSubmitOption="onSubmitOption"
                    :formList="formList"
                    :showTitle="false"
                    :lenderStyle="lenderStyle"
                    :defaultMsg="defaultMsg"
                    :submitText="submitOptionText"
                    :submitStyle="{
                        backgroundColor: submitBgColor,
                    }"
                    :registerLogin="registerLogin"
                    @done="handleShowToast"
                    :changeLabelPos="true"
                    disclaimerColor="#a8a8a8"
                />
            </div>
            <form-toast
                v-model:visible="formToastVisible"
                v-bind="formToastOption"
                @confirm="handleToastConfirm"
            />
        </div>
    </div>
</template>

<script>
import common from '../index';
import infoForm from '../info-form.vue';
import formToast from '@/components/form-toast';
import { normal } from '../../defaultSpacing';
export default {
    mixins: [common],
    data: function() {
        return {
            ...normal,
            bandInfo: '',
            bandLogo: {
                src: 'https://cdn.chime.me/image/fs/sitebuild/202141/0/original_50e40578-c47c-4749-9992-338664b18e32.png',
                mobileSrc:
                    'https://cdn.chime.me/image/fs/sitebuild/202141/0/original_50e40578-c47c-4749-9992-338664b18e32.png'
            }
        };
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        }
    },
    components: {
        infoForm,
        formToast
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-form.broker {
    position: relative;
    width: 100%;
    background-color: #fff;
    @media (min-width: 601px) {
        .mg-container {
            overflow: visible;
        }
    }

    .form-container {
        display: flex;
        position: relative;
        .info-agent {
            flex: 1;
            padding-right: 50px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            .img {
                height: 85px;
                width: 85px;
                padding: 5px;
                border-radius: 50%;
                border: 1px solid #dadada;
                background-color: #fff;
                margin-bottom: 30px;
                @media (max-width: 600px) {
                    width: 65px;
                    height: 65px;
                    margin-bottom: 15px;
                }
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 50%;
                }
            }
            .desc {
                font: 14px var(--font-medium);
                color: #3c3c4c;
                letter-spacing: normal;
                margin-bottom: 70px;
            }
            .concat {
                color: #505050;
                font-size: 12px;
                p {
                    margin-top: 9px;
                    display: flex;
                    align-items: center;
                    overflow: hidden;
                    .iconfont {
                        color: #505050;
                        flex-shrink: 0;
                        margin-right: 8px;
                        display: inline-flex;
                        justify-content: center;
                        align-items: center;
                        width: 16px;
                        height: 16px;
                        &.icon-icon_dianhua {
                            font-size: 18px;
                            height: 18px;
                        }
                        &.icon-email {
                            font-size: 12px;
                        }
                        &.icon-map-v1 {
                            font-size: 16px;
                        }
                    }
                    span a {
                        color: #505050;
                        font: 12px var(--font-normal);
                        @include ellipsis();
                    }
                }
            }
        }
        .info-right {
            flex: 1;
            display: flex;
            flex-direction: column;
            box-shadow: 0 2px 30px 0 rgba(0, 10, 30, 0.1);
            background-color: #ffffff;
            padding: 0 25px 25px;
            position: relative;
            border-radius: 5px;
            overflow: hidden;
            .top-border {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 6px;
                background-image: linear-gradient(
                    to bottom,
                    var(--color-theme),
                    var(--color-theme) 99%
                );
            }
            .title {
                flex: none;
                font-size: 24px;
                color: #000000;
                letter-spacing: 0.21px;
                font-family: var(--mg-title-font);
                line-height: 1.11;
                text-align: left;
                margin-top: 20px;
                margin-bottom: 30px;
                @include webkitBox(2);
                p {
                    line-height: 1;
                    overflow: hidden;
                }
            }
            .info-form {
                display: flex;
                flex-direction: column;
                @include placeholderColor(#c6c8d1);
                input {
                    height: 40px !important;
                }
                input:not(.submit),
                textarea {
                    border: solid 1px #dadada;
                    font: 14px var(--font-medium);
                    box-shadow: unset;
                }
                ::-webkit-input-placeholder {
                    font: 14px var(--font-normal);
                    color: #c6c8d1;
                }
            }
            .input-content {
                flex: 1;
                display: flex;
                flex-direction: column;
            }
            .basic-info {
                flex: none;
                display: flex;
                flex-wrap: wrap;
                margin-left: -20px;
                margin-top: -20px;
                .input-box {
                    flex-grow: 1;
                    min-width: 230px;
                    margin-left: 20px;
                    margin-top: 20px;
                    position: relative;
                    .mg-error {
                        position: absolute;
                        left: 0;
                        bottom: -18px;
                    }
                    &.question {
                        width: calc(100% - 20px);
                        flex: none;
                    }
                    &.meetTime {
                        .el-input {
                            width: 100%;
                        }
                        .el-input__prefix {
                            left: 15px;
                        }
                        input {
                            text-indent: 25px;
                            color: #000000;
                        }
                    }
                }
                .input-box[class*='paragraphText'] {
                    width: 100%;
                }
                input {
                    display: inline-block;
                    font: 14px var(--font-medium);
                    height: 45px;
                    background-color: #fff;
                    border: solid 1px var(--color-border);
                    width: 100%;
                    padding-left: 10px;
                }
                textarea {
                    width: 100%;
                    height: 100px;
                    border: solid 1px var(--color-border);
                    padding: 12px 10px;
                    font-size: 14px;
                }
            }
            .v-input {
                &:focus-within,
                .has-value {
                    .label-top {
                        display: block !important;
                        opacity: 1;
                        top: 0;
                        z-index: 1;
                        padding: 0 5px;
                    }
                }
            }
            .submit-content {
                flex: none;
                margin-top: 20px;
            }
            .submit {
                height: 40px;
                width: 100%;
                padding: 0 20px;
                text-align: center;
                vertical-align: middle;
                font-size: 16px;
                font-family: var(--mg-button-font);
                background: var(--color-theme);
                border-radius: 5px;
                color: #fff;
                opacity: 0.8;
                &:hover {
                    opacity: 1;
                }
            }
        }
    }
    input[type='button'].toast-btn2 {
        font-family: var(--font-bold);
    }
    @include media-1080 {
        .form-container .info-agent {
            margin-right: 30px;
            .agent-detail {
                left: 11px;
                right: 11px;
            }
        }
    }
    @include media-800 {
        .form-container {
            flex-direction: column;
            .info-agent {
                margin-right: 0 !important;
                padding-right: 0;
                & > img {
                    margin-bottom: 15px;
                }
                .desc {
                    margin-bottom: 20px;
                }
            }
            .concat {
                p {
                    &:last-child {
                        margin-bottom: 20px;
                    }
                }
            }
            .info-right {
                padding: 0 15px 15px;
                margin-right: 0;
                margin-bottom: 0;
                .title {
                    margin-bottom: 24px;
                }
            }
        }
    }
    @include media-600 {
        ::-webkit-input-placeholder {
            font-size: 12px;
        }
        ::-moz-placeholder {
            font-size: 12px;
        }
        :-ms-input-placeholder {
            font-size: 12px;
        }
        .form-container {
            overflow: visible;
            .info-agent::after {
                display: block;
                background: #fff;
                top: auto;
                bottom: -20px;
                left: -15px;
                right: -15px;
                height: 1px;
            }
            .info-right {
                margin-right: 0;
                margin-bottom: 0;
                .title {
                    letter-spacing: normal;
                    font-size: 16px;
                    margin-bottom: 24px;
                }
                .basic-info {
                    margin-top: 0px;
                    .input-box {
                        margin-top: 20px;
                        &:first-child {
                            margin-top: 0;
                        }
                    }
                    input {
                        height: 40px;
                        line-height: 22px;
                    }
                    textarea {
                        height: 80px;
                    }
                }
                .submit {
                    height: 40px;
                    width: 100%;
                }
            }
        }
    }
    .md-agent-contact.standard + &,
    .md-banner.standard + & {
        margin-top: 40px;
    }
}
</style>
